var React = require('react');

function SocialLinkedin (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"social-linkedin"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M2.21,0H1.9A1.7,1.7,0,0,0,0,1.48,1.7,1.7,0,0,0,1.48,3.37h.37A1.69,1.69,0,1,0,2.21,0Z","key":0}),React.createElement("rect",{"x":"0.44","y":"4.58","width":"3.03","height":"9.7","key":1}),React.createElement("path",{"d":"M11.75,4.49a3.11,3.11,0,0,0-3,1.62V4.58H5.35v9.7h3.4V9a1.94,1.94,0,0,1,.08-.79,1.72,1.72,0,0,1,1.64-1.19c1.18,0,1.72.9,1.72,2.21v5h3.44V8.89C15.6,5.89,13.9,4.49,11.75,4.49Z","key":2})])]);
}

SocialLinkedin.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 15.63 14.28"};

module.exports = SocialLinkedin;

SocialLinkedin.default = SocialLinkedin;
